import React from 'react';
import { BookOpenIcon, HandIcon, PenLineIcon, RotateCcwIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { fourSteps, scatteredHabits, selfQuestions } from '../../data/lists';
const stepIcons = [BookOpenIcon, HandIcon, PenLineIcon, RotateCcwIcon];
export function Problem() {
  return <section className="bg-paper px-4 py-16 sm:py-20" data-id="element-294" data-mp="2mnhevhifs6mq">
      <div className="mx-auto max-w-3xl" data-id="element-295" data-mp="2hr0hrxt9ehxi">
        <SectionHeading title={<>
              What if you could stop wondering what to practice… and simply follow a{' '}
              <em className="text-cta" data-id="element-297" data-mp="28qc3d1zyefk3">clear reflexology routine?</em>
            </>} data-id="element-296" data-mp="2cr4drykkaqhy" />

        <p className="mt-8 text-center text-lg text-ink" data-id="element-298" data-mp="23rrbpqyrp479">If you're learning reflexology, you've probably experienced this.</p>

        <ol className="mx-auto mt-6 max-w-md space-y-2" data-id="element-299" data-mp="6w3c7lvi37ff">
          {scatteredHabits.map((h, i) => <li key={h} className="rounded-xl border border-sand bg-cream px-4 py-3 text-base font-medium text-ink" style={{
          marginLeft: `${i % 3 * 12}px`,
          marginRight: `${(2 - i % 3) * 12}px`
        }} data-id="element-300" data-mp="1x8llxrakekr" data-mpi={i}>
              {h}
            </li>)}
        </ol>

        <p className="mt-8 text-center text-lg text-ink" data-id="element-301" data-mp="109gtv9xv6xkq">
          And then, when you finally have time to practice, you find yourself asking:
        </p>
        <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-302" data-mp="1nzktl67xmd6g">
          {selfQuestions.map(q => <li key={q} className="rounded-2xl bg-blush px-5 py-4 text-center font-serif text-lg font-semibold italic text-ink" data-id="element-303" data-mp="1s04sae85loup">
              “{q}”
            </li>)}
        </ul>

        <div className="mt-10 space-y-4 text-center text-lg leading-relaxed text-ink" data-id="element-304" data-mp="1j71gead5pk26">
          <p data-id="element-305" data-mp="26wvt8rxh78mf">I've seen this happen again and again. And I realized something important:</p>
          <blockquote className="rounded-2xl bg-forest px-6 py-6 text-cream" data-id="element-306" data-mp="2bovmk1j1j3a1">
            <p className="font-serif text-xl font-semibold sm:text-2xl" data-id="element-307" data-mp="2lkcab0ohpj03">The problem isn't always a lack of information.</p>
            <p className="mt-2 text-cream/85" data-id="element-308" data-mp="2gl9du4mksl3q">
              Sometimes, the problem is having no clear structure for turning that information into practice.
            </p>
          </blockquote>
          <p data-id="element-309" data-mp="26o4qi1gzujlc">
            That's exactly why I created <strong className="text-forest" data-id="element-310" data-mp="26pfvu5q37zek">REFLEXOLOGY 21-DAY PRACTICE METHOD™</strong>.
          </p>
          <p className="text-muted" data-id="element-311" data-mp="22numgucri394">
            I didn't want to create another reflexology ebook that you read once and forget. I wanted to create something you
            could actually use every day. Something that would open with a simple instruction:
          </p>
          <p className="font-serif text-2xl font-bold italic text-forest" data-id="element-312" data-mp="1ny6j7nl0suir">“Here's what to do today.”</p>
          <p data-id="element-313" data-mp="1ix94jkz7yim0">So I built a 21-day system around four simple steps:</p>
        </div>

        <ol className="mt-6 grid grid-cols-2 gap-3 md:grid-cols-4" data-id="element-314" data-mp="1ex8h5au56x2t">
          {fourSteps.map((s, i) => {
          const Icon = stepIcons[i];
          return <li key={s.label} className="flex flex-col items-center rounded-2xl border border-forest/15 bg-cream px-3 py-5 text-center" data-id="element-315" data-mp="3ukuh3mqvffik" data-mpi={i}>
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-forest text-cream" data-id="element-316" data-mp="3g4fnun18nvy">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-317" data-mp="8d4nob3g00pp" />
                </span>
                <span className="mt-3 text-xs font-bold text-cta" data-id="element-318" data-mp="36wutuwsrq78q">STEP {i + 1}</span>
                <span className="font-serif text-xl font-bold uppercase text-forest" data-id="element-319" data-mp="3bvo48gcrdi4o">{s.label}</span>
                <span className="mt-1 text-sm text-muted" data-id="element-320" data-mp="3gsoaosdismwb">{s.text}</span>
              </li>;
        })}
        </ol>
        <p className="mt-6 text-center text-lg font-semibold text-ink" data-id="element-321" data-mp="3llqx8gjvqw30">
          For approximately 15 minutes a day. One step at a time.
        </p>

        <div className="mt-10" data-id="element-322" data-mp="2t3lod77xy5vh">
          <CTAButton label="Yes! Show me the 21-day reflexology method" note="Instant access · One-time payment of $27 · 7-Day Guarantee" data-id="element-323" data-mp="2t2k8mpfzcv7f" />
        </div>
      </div>
    </section>;
}